import axios from './axios';

const TOKEN_KEY = 'taa-shop-token';
const CUSTOMER_KEY = 'taa-shop-customer';
const COLLECTIONS_KEY = 'taa-shop-collections';

export function getShopToken() {
  return localStorage.getItem(TOKEN_KEY) || '';
}

export function getShopCustomer() {
  try {
    return JSON.parse(localStorage.getItem(CUSTOMER_KEY) || 'null');
  } catch {
    return null;
  }
}

export function isShopLoggedIn() {
  return Boolean(getShopToken() && getShopCustomer());
}

export function setShopSession(payload) {
  if (!payload?.token) return;
  const customer = {
    id: payload.id,
    name: payload.name,
    email: payload.email,
    phone: payload.phone,
    city: payload.city || '',
    address: payload.address || '',
  };
  localStorage.setItem(TOKEN_KEY, payload.token);
  localStorage.setItem(CUSTOMER_KEY, JSON.stringify(customer));
  window.dispatchEvent(new Event('taa-shop-auth'));
}

export function clearShopSession() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(CUSTOMER_KEY);
  window.dispatchEvent(new Event('taa-shop-auth'));
}

export function readLocalCollections() {
  try {
    const list = JSON.parse(localStorage.getItem(COLLECTIONS_KEY) || '[]');
    return Array.isArray(list) ? list : [];
  } catch {
    return [];
  }
}

export function writeLocalCollections(list) {
  localStorage.setItem(COLLECTIONS_KEY, JSON.stringify(list));
  window.dispatchEvent(new Event('taa-shop-collections'));
}

export function addLocalCollection(name, slug) {
  const list = readLocalCollections();
  const collection = {
    id: `local-${Date.now()}`,
    name,
    slugs: slug ? [slug] : [],
  };
  list.unshift(collection);
  writeLocalCollections(list);
  return collection;
}

function authBody() {
  return {
    saved_slugs: JSON.parse(localStorage.getItem('taa-shop-saved') || '[]'),
    followed_slugs: JSON.parse(localStorage.getItem('taa-shop-followed-coops') || '[]'),
    collections: readLocalCollections().map((item) => ({
      name: item.name,
      slugs: item.slugs || [],
    })),
  };
}

export async function shopRegister(fields) {
  const res = await axios.post('/api/shop/auth/register/', { ...fields, ...authBody() });
  setShopSession(res.data);
  return res.data;
}

export async function shopLogin(fields) {
  const res = await axios.post('/api/shop/auth/login/', { ...fields, ...authBody() });
  setShopSession(res.data);
  return res.data;
}

export async function shopLogout() {
  try {
    await axios.post('/api/shop/auth/logout/');
  } catch {
    /* ignore */
  }
  clearShopSession();
}

async function shopGet(url) {
  try {
    const res = await axios.get(url);
    return res.data;
  } catch (err) {
    if (err.response?.status === 401) {
      clearShopSession();
    }
    throw err;
  }
}

export async function fetchShopMe() {
  return shopGet('/api/shop/me/');
}

export async function fetchShopOrders() {
  return shopGet('/api/shop/me/orders/');
}

export async function fetchShopCollections() {
  return shopGet('/api/shop/me/collections/');
}

export async function saveShopProduct(slug, collectionId) {
  const res = await axios.post('/api/shop/me/saved/', {
    slug,
    collection_id: collectionId || undefined,
  });
  return res.data;
}

export async function unsaveShopProduct(slug) {
  await axios.delete(`/api/shop/me/saved/${slug}/`);
}

export async function createShopCollection(name, slug) {
  const res = await axios.post('/api/shop/me/collections/', { name, slug: slug || undefined });
  return res.data;
}

export async function fetchShopFollows() {
  return shopGet('/api/shop/me/follows/');
}

export async function followShopCoop(slug) {
  const res = await axios.post('/api/shop/me/follows/', { slug });
  return res.data;
}

export async function unfollowShopCoop(slug) {
  await axios.delete(`/api/shop/me/follows/${slug}/`);
}
